import React from "react";
import { PropagateLoader } from "react-spinners";

function BoardingDropping({
  show,
  closeFilter,
  boardingPoints = [],
  droppingPoints = [],
  loading,
}) {
  if (!show) return null;
  return (
    <div
      className="mobile heading_flight_list_two heading_flight_list_three heading_flight_list_four"
      style={{ zIndex: "10000000" }}
    >
      <div className="actpop fltr-pop" id="idflr">
        <div className="popbx">
          <div className="close-btn fltPop" onClick={closeFilter}>
            ✕
          </div>
          <div className="ovf-sc">
            {loading ? (
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <PropagateLoader color="#1a4f87" />
              </div>
            ) : (
              <div className="Buslisting-boardingPoints">
                <div className="Buslisting-boarding-column">
                  <h4>Boarding Points</h4>
                  <ul>
                    {boardingPoints?.map((point, i) => (
                      <li key={i}>
                        {new Date(point.CityPointTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })}{" "}
                        {point.CityPointName}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="Buslisting-boarding-column">
                  <h4>Dropping Points</h4>
                  <ul>
                    {droppingPoints?.map((point, i) => (
                      <li key={i}>
                        {new Date(point.CityPointTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })}{" "}
                        {point.CityPointName}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BoardingDropping;
